import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_7 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "px-7 py-5" }, [
      _createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter Options")
    ], -1)),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "separator border-gray-200" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fw-bold" }, "Status:", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            placeholder: "Select option",
            modelValue: _ctx.data.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.status) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Approved",
                value: "1"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Approved")
                ])),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "Pending",
                value: "2"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Pending")
                ])),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "In Process",
                value: "3"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("In Process")
                ])),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "Rejected",
                value: "4"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Rejected")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label fw-bold" }, "Member Type:", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _createVNode(_component_el_checkbox, {
              type: "checkbox",
              value: "1",
              modelValue: _ctx.data.author,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.author) = $event))
            }, null, 8, ["modelValue"]),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "form-check-label" }, " Author ", -1))
          ]),
          _createElementVNode("label", _hoisted_7, [
            _createVNode(_component_el_checkbox, {
              type: "checkbox",
              value: "2",
              modelValue: _ctx.data.customer,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.customer) = $event))
            }, null, 8, ["modelValue"]),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "form-check-label" }, " Customer ", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label fw-bold" }, "Notifications:", -1)),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            name: "notifications",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.notifications) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.data.notifications]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-check-label" }, " Enabled ", -1))
        ])
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-flex justify-content-end" }, [
        _createElementVNode("button", {
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true"
        }, " Reset "),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true"
        }, " Apply ")
      ], -1))
    ])
  ]))
}